import styled from '@emotion/styled';
import { gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const StyledRange = styled.div`
    display: flex;
    align-items: flex-end;
    grid-gap: ${gutterSizes.medium};
`;
